"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentHistoryItemDtoTierEnum = void 0;
exports.instanceOfPaymentHistoryItemDto = instanceOfPaymentHistoryItemDto;
exports.PaymentHistoryItemDtoFromJSON = PaymentHistoryItemDtoFromJSON;
exports.PaymentHistoryItemDtoFromJSONTyped = PaymentHistoryItemDtoFromJSONTyped;
exports.PaymentHistoryItemDtoToJSON = PaymentHistoryItemDtoToJSON;
exports.PaymentHistoryItemDtoToJSONTyped = PaymentHistoryItemDtoToJSONTyped;
/**
 * @export
 */
exports.PaymentHistoryItemDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the PaymentHistoryItemDto interface.
 */
function instanceOfPaymentHistoryItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('currency' in value) || value['currency'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function PaymentHistoryItemDtoFromJSON(json) {
    return PaymentHistoryItemDtoFromJSONTyped(json, false);
}
function PaymentHistoryItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'provider': json['provider'],
        'status': json['status'],
        'amount': json['amount'],
        'currency': json['currency'],
        'tier': json['tier'] == null ? undefined : json['tier'],
        'planCode': json['planCode'] == null ? undefined : json['planCode'],
        'paidAt': json['paidAt'] == null ? undefined : json['paidAt'],
        'createdAt': json['createdAt'],
    };
}
function PaymentHistoryItemDtoToJSON(json) {
    return PaymentHistoryItemDtoToJSONTyped(json, false);
}
function PaymentHistoryItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'provider': value['provider'],
        'status': value['status'],
        'amount': value['amount'],
        'currency': value['currency'],
        'tier': value['tier'],
        'planCode': value['planCode'],
        'paidAt': value['paidAt'],
        'createdAt': value['createdAt'],
    };
}
